export default function ReportDisabled() {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-6">
      <div className="text-center">
        <h1 className="text-xl font-semibold text-foreground mb-2">Report disabled</h1>
        <p className="text-sm text-muted-foreground">This report is disabled for now.</p>
      </div>
    </div>
  );
}
